// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';

// Material Kit 2 React examples
import CenteredBlogCard from 'examples/Cards/BlogCards/CenteredBlogCard';
import MKTypography from 'components/MKTypography';
import {
  Diversity3Sharp,
  GppGoodSharp,
  HandshakeSharp,
  PolicySharp,
  TrendingUpSharp,
  VerifiedUserSharp,
} from '@mui/icons-material';
import { Stack } from '@mui/material';

import impact_img from 'assets/csdd_images/impact_img.jpg';

function OurVision() {
  return (
    <MKBox component='section' py={12}>
      <Container>
        <Grid container spacing={3} justifyContent='center' alignItems='center'>
          <Grid item xs={12} lg={4} sx={{ ml: 'auto', my: { xs: 3, md: 2 } }}>
            <CenteredBlogCard
              color='black'
              image={impact_img}
              title='Our Vision'
              description='Our goal is to promote economic empowerment and opportunities for Micro, Small and Medium Enterprises (MSMEs).'
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox sx={{ display: 'flex', justifyContent: 'center' }}>
              <Stack>
                <MKTypography
                  textAlign='center'
                  color='white'
                  variant='h2'
                  my={1}
                >
                  Our Values
                </MKTypography>
                <MKBox display='flex' alignItems='center' p={2}>
                  <Diversity3Sharp color='white' fontSize='large' />
                  <MKTypography
                    variant='body2'
                    color='light'
                    pl={2}
                    fontWeight='medium'
                  >
                    Advocate
                  </MKTypography>
                </MKBox>
                <MKBox display='flex' alignItems='center' p={2}>
                  <TrendingUpSharp color='white' fontSize='large' />
                  <MKTypography
                    variant='body2'
                    color='light'
                    pl={2}
                    fontWeight='medium'
                  >
                    Develop
                  </MKTypography>
                </MKBox>
                <MKBox display='flex' alignItems='center' p={2}>
                  <GppGoodSharp color='white' fontSize='large' />
                  <MKTypography
                    variant='body2'
                    color='light'
                    pl={2}
                    fontWeight='medium'
                  >
                    Certify
                  </MKTypography>
                </MKBox>
                <MKBox display='flex' alignItems='center' p={2}>
                  <Diversity3Sharp color='white' fontSize='large' />
                  <MKTypography
                    variant='body2'
                    color='light'
                    pl={2}
                    fontWeight='medium'
                  >
                    Connect
                  </MKTypography>
                </MKBox>
              </Stack>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default OurVision;
